/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoadmapResourceBandsDto } from './RoadmapResourceBandsDto';
import {
    RoadmapResourceBandsDtoFromJSON,
    RoadmapResourceBandsDtoFromJSONTyped,
    RoadmapResourceBandsDtoToJSON,
    RoadmapResourceBandsDtoToJSONTyped,
} from './RoadmapResourceBandsDto';
import type { RoadmapPeriodDto } from './RoadmapPeriodDto';
import {
    RoadmapPeriodDtoFromJSON,
    RoadmapPeriodDtoFromJSONTyped,
    RoadmapPeriodDtoToJSON,
    RoadmapPeriodDtoToJSONTyped,
} from './RoadmapPeriodDto';
import type { InitiativeDependencyDto } from './InitiativeDependencyDto';
import {
    InitiativeDependencyDtoFromJSON,
    InitiativeDependencyDtoFromJSONTyped,
    InitiativeDependencyDtoToJSON,
    InitiativeDependencyDtoToJSONTyped,
} from './InitiativeDependencyDto';
import type { RoadmapInitiativeRowDto } from './RoadmapInitiativeRowDto';
import {
    RoadmapInitiativeRowDtoFromJSON,
    RoadmapInitiativeRowDtoFromJSONTyped,
    RoadmapInitiativeRowDtoToJSON,
    RoadmapInitiativeRowDtoToJSONTyped,
} from './RoadmapInitiativeRowDto';

/**
 * 
 * @export
 * @interface ProgramRoadmapDto
 */
export interface ProgramRoadmapDto {
    /**
     * 
     * @type {Date}
     * @memberof ProgramRoadmapDto
     */
    horizonStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProgramRoadmapDto
     */
    horizonEnd?: Date;
    /**
     * 
     * @type {Array<RoadmapPeriodDto>}
     * @memberof ProgramRoadmapDto
     */
    periods?: Array<RoadmapPeriodDto>;
    /**
     * 
     * @type {Array<RoadmapInitiativeRowDto>}
     * @memberof ProgramRoadmapDto
     */
    initiatives?: Array<RoadmapInitiativeRowDto>;
    /**
     * 
     * @type {Array<InitiativeDependencyDto>}
     * @memberof ProgramRoadmapDto
     */
    initiativeDependencies?: Array<InitiativeDependencyDto>;
    /**
     * 
     * @type {RoadmapResourceBandsDto}
     * @memberof ProgramRoadmapDto
     */
    resourceBands?: RoadmapResourceBandsDto;
}

/**
 * Check if a given object implements the ProgramRoadmapDto interface.
 */
export function instanceOfProgramRoadmapDto(value: object): value is ProgramRoadmapDto {
    return true;
}

export function ProgramRoadmapDtoFromJSON(json: any): ProgramRoadmapDto {
    return ProgramRoadmapDtoFromJSONTyped(json, false);
}

export function ProgramRoadmapDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramRoadmapDto {
    if (json == null) {
        return json;
    }
    return {
        
        'horizonStart': json['horizonStart'] == null ? undefined : (new Date(json['horizonStart'])),
        'horizonEnd': json['horizonEnd'] == null ? undefined : (new Date(json['horizonEnd'])),
        'periods': json['periods'] == null ? undefined : ((json['periods'] as Array<any>).map(RoadmapPeriodDtoFromJSON)),
        'initiatives': json['initiatives'] == null ? undefined : ((json['initiatives'] as Array<any>).map(RoadmapInitiativeRowDtoFromJSON)),
        'initiativeDependencies': json['initiativeDependencies'] == null ? undefined : ((json['initiativeDependencies'] as Array<any>).map(InitiativeDependencyDtoFromJSON)),
        'resourceBands': json['resourceBands'] == null ? undefined : RoadmapResourceBandsDtoFromJSON(json['resourceBands']),
    };
}

export function ProgramRoadmapDtoToJSON(json: any): ProgramRoadmapDto {
    return ProgramRoadmapDtoToJSONTyped(json, false);
}

export function ProgramRoadmapDtoToJSONTyped(value?: ProgramRoadmapDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'horizonStart': value['horizonStart'] == null ? undefined : ((value['horizonStart']).toISOString().substring(0,10)),
        'horizonEnd': value['horizonEnd'] == null ? undefined : ((value['horizonEnd']).toISOString().substring(0,10)),
        'periods': value['periods'] == null ? undefined : ((value['periods'] as Array<any>).map(RoadmapPeriodDtoToJSON)),
        'initiatives': value['initiatives'] == null ? undefined : ((value['initiatives'] as Array<any>).map(RoadmapInitiativeRowDtoToJSON)),
        'initiativeDependencies': value['initiativeDependencies'] == null ? undefined : ((value['initiativeDependencies'] as Array<any>).map(InitiativeDependencyDtoToJSON)),
        'resourceBands': RoadmapResourceBandsDtoToJSON(value['resourceBands']),
    };
}

